import { registerHandlerOnCallbackError } from '../callback-error-handler';

import { globalErrorHandler } from './register-error-handlers';

export const registerCallbackErrorHandler = () => registerHandlerOnCallbackError(globalErrorHandler);
